module.exports = __webpack_public_path__ + "static/media/radar.782d0f46.jpg";